// extracted by mini-css-extract-plugin
module.exports = {"horizontalScroll":"ScrollBarStyles_horizontalScroll__3GWHV","verticalScroll":"ScrollBarStyles_verticalScroll__-bcOZ"};